/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from 'antd';
import { injectIntl } from 'react-intl';
import classNames from 'classnames/bind';

import styles from '../TopPanel.less';

const cx = classNames.bind(styles);
const Help = ({ intl }) => {
  const { formatMessage } = intl;
  return (
    <div data-role='helpBtn'>
      <a target='_blank' className={cx('helpBtn')} href='https://docs.logixcrm.com/crm'>
        <Icon className='mr-sm' type='question-circle' />
        {formatMessage({ id: 'global.ui.button.help' })}
      </a>
    </div>
  );
};

export default injectIntl(Help);



// WEBPACK FOOTER //
// ./src/components/page/TopPanel/component/help.js